module.exports = __webpack_public_path__ + "img/expostyle_9522_richelieu_red_pantone7622c.ae426fc2.jpg";